import { replaceInUrl, postRequest, putRequest, deleteRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const createApplicationFundingRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding.applicationFunding, {
      ApplicationUid,
    }),
    data,
  );

export const updateApplicationFundingRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding.applicationFunding, {
      ApplicationUid,
    }),
    data,
  );

export const deleteApplicationFundingRequest = ({ ApplicationUid }) =>
  deleteRequest(
    replaceInUrl(apiEndpoints.funding.applicationFunding, {
      ApplicationUid,
    }),
  );

export const createBankApplicationFundingRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding.bankApplicationFunding, {
      ApplicationUid,
    }),
    data,
  );

export const updateBankApplicationFundingRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding.bankApplicationFunding, {
      ApplicationUid,
    }),
    data,
  );

export const createApplicationFundingAmountRequest = ({
  ApplicationUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding.applicationFundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const updateApplicationFundingAmountRequest = ({
  ApplicationUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding.applicationFundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const createBankApplicationFundingAmountRequest = (
  ApplicationUid,
  data,
) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding.bankApplicationFundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const updateBankApplicationFundingAmountRequest = (
  ApplicationUid,
  data,
) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding.bankApplicationFundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const createMetalStreamFundingRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding.postMetalStreamFunding, {
      ApplicationUid,
    }),
    data,
  );

export const updateMetalStreamFundingRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding.updateMetalStreamFunding, {
      ApplicationUid,
    }),
    data,
  );
